import script from "./allDirectorsOrActor.vue?vue&type=script&lang=ts&setup=true"
export * from "./allDirectorsOrActor.vue?vue&type=script&lang=ts&setup=true"

import "./allDirectorsOrActor.vue?vue&type=style&index=0&id=3598cc0a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3598cc0a"]])

export default __exports__